import { useInjectedService } from '../../services/ioc/service-dependency';
import './terms-of-use.css';

const TermsOfUse = () => {
    const { localizationService } = useInjectedService();

    return <div className="bbraun-hero bbraun-terms-of-use">
        <h2 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("TermsOfUseMFAHeadline") }} />
        <br /> <br />
        <h3 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("TermsOfUseMFASubHeadline1") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("TermsOfUseMFASubText1") }} />
        <br /> <br />
        <h3 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("TermsOfUseMFASubHeadline2") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("TermsOfUseMFASubText2") }} />
        <br /> <br />
        <h3 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("TermsOfUseMFASubHeadline3") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("TermsOfUseMFASubText3") }} />
        <br /> <br />
        <h3 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("TermsOfUseMFASubHeadline4") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("TermsOfUseMFASubText4") }} />
        <br /> <br />
        <h3 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("TermsOfUseMFASubHeadline5") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("TermsOfUseMFASubText5") }} />
        <br /> <br />
        <h3 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("TermsOfUseMFASubHeadline6") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("TermsOfUseMFASubText6") }} />
        <br /> <br />
        <h3 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("TermsOfUseMFASubHeadline7") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("TermsOfUseMFASubText7") }} />
        <br /> <br />
        <h3 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("TermsOfUseMFASubHeadline8") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("TermsOfUseMFASubText8") }} />
        <br /> <br />
        <h3 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("TermsOfUseMFASubHeadline9") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("TermsOfUseMFASubText9") }} />
        <br /> <br />
        <h3 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("TermsOfUseMFASubHeadline10") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("TermsOfUseMFASubText10") }} />
        <br /> <br />
        <h3 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("TermsOfUseMFASubHeadline11") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("TermsOfUseMFASubText11") }} />
        <br /> <br />
        <h3 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("TermsOfUseMFASubHeadline12") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("TermsOfUseMFASubText12") }} />

        <br />

        <p>
            <b>BKC-App Support: </b> <a href={'mailto:' + localizationService.getLocalizedText("SupportEmail")}>{localizationService.getLocalizedText("SupportEmail")}</a>
        </p>
    </div >;
}

export default TermsOfUse;